import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-google",
  "use": "icon-google-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol viewBox=\"0 0 96 96\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-google\">\n    <title>icon/标识/google</title>\n    <g id=\"icon-google_icon/标识/google\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M86.3851351,41.3243243 L47.797973,41.3243243 L47.797973,55.5628378 L71.0047297,55.5628378 C67.825,65.2337838 58.7337838,72.2256757 48,72.2256757 C34.6222973,72.2256757 23.7743243,61.3777027 23.7743243,48 C23.7743243,34.6222973 34.6222973,23.7743243 48,23.7743243 C54.2013514,23.7743243 59.8493243,26.1283784 64.127027,29.9581081 L73.9912162,18.9871622 C67.0871622,12.7945946 57.9959459,9 48,9 C26.4533784,9 9,26.4621622 9,48 C9,69.5378378 26.4533784,87 48,87 C69.5378378,87 87,69.5378378 87,48 C87,45.7162162 86.7628378,43.4939189 86.3851351,41.3243243\" id=\"icon-google_路径\" fill=\"currentColor\" fill-rule=\"nonzero\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/google.svg
// module id = YgBy
// module chunks = 3